import React from 'react';
import {
  DashboardIcon,
  DomainManagement,
  Organization,
  AdvancedAPIManagement,
  AuthenticationSettings,
  PermissionManagement,
  RoleManagement,
  UserandGroups,
  ApplicationManagement,
  Meeting,
} from '@/icons';

interface UrlLink {
  id: string;
  label?: string;
  url?: string;
  isSubLinks?: boolean;
  useStroke?: boolean;
  title?: string;
}

export interface NavLink extends UrlLink {
  icon?: React.ReactNode;
  navigate?: () => void;
}

const pageIndexes = {
  dashboard: 'DASHBOARD',
  'domain-management': 'DOMAIN_MANAGEMENT',
  'organization-management': 'ORGANIZATION_MANAGEMENT',
  'permission-management': 'PERMISSION_MANAGEMENT',
  'role-management': 'ROLE_MANAGEMENT',
  'users-and-groups': 'USERS_AND_GROUP_MANAGEMENT',
  'application-management': 'APPLICATION_MANAGEMENT',
  'advanced-api-management': 'ADVANCED_API_MANAGEMENT',
  'authentication-settings': 'AUTHENTICATION_SETTINGS',
};

const _dashboardLinks: Array<NavLink> = [
  {
    id: '$home',
    icon: <DashboardIcon />,
    label: 'Dashboard',
    url: '/dashboard',
    title: pageIndexes['dashboard'],
  },
  // {
  //   id: '$home',
  //   icon: <DomainManagement />,
  //   label: 'Domain Management',
  //   url: '/dashboard/domain-management',
  //   useStroke: true,
  //   title: pageIndexes['domain-management'],
  // },
  {
    id: '$home',
    icon: <Organization />,
    label: 'Organization Management',
    url: '/dashboard/organization-management',
    title: pageIndexes['organization-management'],
  },
  {
    id: '$home',
    icon: <PermissionManagement />,
    label: 'Permission Management',
    url: '/dashboard/permission-management',
    title: pageIndexes['permission-management'],
  },
  {
    id: '$home',
    icon: <RoleManagement />,
    label: 'Role Management',
    url: '/dashboard/role-management',
    title: pageIndexes['role-management'],
  },
  {
    id: '$home',
    icon: <UserandGroups />,
    label: 'User and Groups',
    url: '/dashboard/users-and-groups',
    title: pageIndexes['users-and-groups'],
  },
  {
    id: '$home',
    icon: <ApplicationManagement />,
    label: 'Application Management',
    url: '/dashboard/application-management',
    title: pageIndexes['application-management'],
  },
  {
    id: '$home',
    icon: <AdvancedAPIManagement />,
    label: 'Advanced API Management',
    url: '/dashboard/advanced-api-management',
    title: pageIndexes['advanced-api-management'],
  },
  {
    id: '$home',
    icon: <AuthenticationSettings />,
    label: 'Authentication Settings',
    url: '/dashboard/authentication-settings',
    title: pageIndexes['authentication-settings'],
  },
];

const _adminDashboardLinks: Array<NavLink> = [
  {
    id: '$home',
    icon: <DashboardIcon />,
    label: 'Application Creation',
    url: '/dashboard/application-creation',
    useStroke: true,
  },
  {
    id: '$home',
    icon: <DomainManagement />,
    label: 'Entities',
    url: '/dashboard/entities',
  },
  {
    id: '$home',
    icon: <DashboardIcon />,
    label: 'Mapping Management',
    url: '/dashboard/mapping-management',
  },
  {
    id: '$domain-admin',
    icon: <Meeting />,
    label: 'Domains',
    url: '/dashboard/admin-domain-management',
  },
];

export { _dashboardLinks, _adminDashboardLinks };
